import { lazy } from "react";
import Advertisement from "../views/Advertisement";
import EditAdvertisement from "../views/EditAdvertisement";

const Layout = lazy(() => import("../views/Layout"))
const Dashboard = lazy(() => import("../views/Dashboard"));
const ChangePassword = lazy(() => import("../views/ChangePassword"))
const Workshops = lazy(() => import("../views/Workshops"));
const EditWorkshop = lazy(() => import("../views/EditWorkshop"));
const CreateWorkshop = lazy(() => import("../views/CreateWorkshop"));

const Chargers = lazy(() => import("../views/Chargers"));
const EditCharger = lazy(() => import("../views/EditCharger"));
const CreateCharger = lazy(() => import("../views/CreateCharger"));

const CreateAdvertisement = lazy(() => import("../views/CreateAdvertisement"))

const Users = lazy(() => import("../views/Users"))
const CreateUser = lazy(() => import("../views/CreateUser"))
const CarList = lazy(() => import("../views/CarList"))

export const privateRoutes = [
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        path: "/",
        element: <Dashboard />,
      },
      {
        path: "/change-password",
        element: <ChangePassword />,
      },
      {
        path: "/chargers",
        element: <Chargers />,
      },
      {
        path: "/chargers/:id",
        element: <EditCharger />,
      },
      {
        path: "/chargers/create",
        element: <CreateCharger />,
      },
      {
        path: "/workshops",
        element: <Workshops />,
      },
      {
        path: "/workshops/create",
        element: <CreateWorkshop />
      },
      {
        path: "/workshops/:id",
        element: <EditWorkshop />
      },
      {
        path: "/advertisement",
        element: <Advertisement />
      },
      {
        path: "/advertisement/create",
        element: <CreateAdvertisement />
      },
      {
        path: "/advertisement/:id",
        element: <EditAdvertisement />
      },
      {
        path: "/cars-list",
        element: <CarList />
      },
      {
        path: "/users",
        element: <Users />
      },
      {
        path: "/users/create",
        element: <CreateUser />
      },
    ],
  },
];
